import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import prodUser from './slices/prodUserSlice'
import cs from './slices/csSlice'
import or from './slices/orSlice'
import component from './slices/componentSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        prodUser,
        cs,
        or,
        component,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
